export default __webpack_public_path__ + "static/06-91aafcc032f5c7602573e8f0d8bb8c58.jpg";